const RRHH_CORE_API_BASE = '/api/rrhh';

async function rrhhCoreRequest(path, options = {}) {
  const response = await fetch(`${RRHH_CORE_API_BASE}${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  let payload = null;
  try { payload = await response.json(); } catch { payload = null; }
  if (!response.ok) {
    const error = new Error(payload?.error || 'No se pudo conectar con RRHH');
    error.status = response.status;
    throw error;
  }
  return payload;
}

export function rrhhCoreGet(path) { return rrhhCoreRequest(path); }
export function rrhhCorePost(path, body) {
  return rrhhCoreRequest(path, { method: 'POST', body: JSON.stringify(body) });
}
export function rrhhCorePatch(path, body) {
  return rrhhCoreRequest(path, { method: 'PATCH', body: JSON.stringify(body) });
}
